export default "__VITE_ASSET__4304dcdf__"